import { StoreApi } from 'zustand';
import { MediaAssetType } from '@/types/media';

export enum MediaAssetProviders {
  stock = 'stock',
  library = 'library',
  instagram = 'instagramGraph',
  googleDrive = 'googleDrive',
  dropbox = 'dropbox',
  product = 'product',
  uploaded = 'uploaded',
  aiGenerated = 'aiGenerated',
  tiktok = 'tiktok',
  playApp = 'shopify',
}

export enum MediaAssetProvidersDisplayNames {
  stock = 'Stock',
  library = 'Library',
  instagram = 'Instagram',
  instagramGraph = 'Instagram',
  googleDrive = 'Google Drive',
  dropbox = 'Dropbox',
  product = 'Shopify',
  uploaded = 'Uploaded',
  aiGenerated = 'AI Generated',
  tiktok = 'TikTok',
  playApp = 'Shopify',
}

export type VideoAssetSettings = {
  playFrom?: number;
  playTill?: number;
  duration: number;
};

export type ImageAssetSettings = {
  paceholderImageProp: number; // Just a placeholder for now
};

export type ProductMediaAsset<T = VideoAssetSettings | ImageAssetSettings> = {
  type: MediaAssetType;
  id: string;
  alt?: string;
  provider?: string;
  src: string;
  previewImage?: string;
  settings?: T;
  source?: string;
};

export type ProductMedia = {
  productMedia: ProductMediaAsset[];
  playType: 'loop' | 'timed';
};

export type ProductMediaSliceState = {
  productMedia: ProductMediaAsset[];
  isProductMediaLoading: boolean;
  playType: 'loop' | 'timed';
};

export type ProductMediaSliceActions = {
  setProductMedia: (productMedia: ProductMediaAsset[]) => void;
  addProductMedia: (productMedia: ProductMediaAsset[]) => void;
  setIsProductMediaLoading: (isProductMediaLoading: boolean) => void;
  setPlayType: (playType: 'loop' | 'timed') => void;
};

type ProductMediaSlice = ProductMediaSliceState & ProductMediaSliceActions;

export const productMediaSliceInitialState: ProductMediaSliceState = {
  productMedia: [],
  isProductMediaLoading: false,
  playType: 'timed',
};

export const createProductMediaSliceActions = (
  set: StoreApi<ProductMediaSlice>['setState']
): ProductMediaSliceActions => ({
  setPlayType: (playType: 'loop' | 'timed') => set({ playType }),
  setProductMedia: (productMedia: ProductMediaAsset[]) => set({ productMedia }),

  addProductMedia: (productMedia: ProductMediaAsset[]) =>
    set((state) => ({
      productMedia: [...state.productMedia, ...productMedia],
    })),

  setIsProductMediaLoading: (isProductMediaLoading: boolean) => set({ isProductMediaLoading }),
});
